import React from 'react'
import {connect} from 'react-redux';
import ConversationModel from '/app/src/model/Conversation/model';
import ConversationSelector from '/app/src/model/Conversation/selector';
import CustomerSelector from '/app/src/model/Customer/selector';
import EmployeesSelector from '/app/src/model/Employee/selector';
import TabIcon from '../TabIcon';
import AssignedOverview from '../Assigned/Overview';
import AssignedTicketInfo from '../Assigned/TicketInfo';
import AssignedOption from '../Assigned/Option';
import {Flex, Div, Tabs} from '/app/src/component'
import MessagesList from '/app/src/component/Conversation/MessagesList';

class AssignedOptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: 0,
            openedCurrentConversationSection: [],
        }
        this.onTabClick= this.onTabClick.bind(this);
    }

    onTabClick(index) {
        this.setState({
            selectedIndex: index
        })
        if(index === 1){
            if (!ConversationSelector.hasBeenFetched(this.props.conversation)) {
                this.props.dispatch(ConversationModel.readEntries(this.props.room))
            }
        }
    }

    componentWillReceiveProps(nextProps){
        const conversation = this.props.conversation;
        const nextConversation = nextProps.conversation;

        const customerId = conversation.getIn(['info', 'customer_id']);
        const nextCustomerId = nextConversation.getIn(['info', 'customer_id']);


        if(customerId !== nextCustomerId){
            this.setState({
                selectedIndex: 0
            })
        }
        if(this.props.room !== nextProps.room){
            if (!ConversationSelector.hasBeenFetched(nextProps.conversation)) {
                this.props.dispatch(ConversationModel.readEntries(nextProps.room))
            }
        }
    }
    render(){
            // onclick={this.claimTicket}
        const customer = this.props.customer;
        const onlineCoworkers = this.props.onlineCoworkers;
        const room = this.props.room;
        const selectedIndex = this.state.selectedIndex;

        if(!customer){
            return <Flex grow column center>
                <h1> {'Något gick fel. Testa att logga ut och in igen.'} </h1>
            </Flex>;
        }

        let tab0H = <TabIcon svgSrc='/images/Customer_S.svg' active={selectedIndex} index={0} onClick={this.onTabClick}/>
        let tab1H = <TabIcon svgSrc='/images/Menu_Conversations_S.svg' active={selectedIndex} index={1} onClick={this.onTabClick}/>
        let tab2H = <TabIcon svgSrc='/images/Menu_History_S.svg' active={selectedIndex} index={2} onClick={this.onTabClick}/>
        let tab3H = <TabIcon svgSrc='/images/Options_S.svg' active={selectedIndex} index={3} onClick={this.onTabClick}/>

        let tab0 = (
            <Div overflowY='auto' w='100%'>
                <AssignedOverview customer={customer}/>
            </Div>
        )


        let tab1 = <AssignedTicketInfo room={room} customer={customer}/>
        let tab2 = <MessagesList room={room}/>
        let tab3 = <AssignedOption customer={customer} coworkers={onlineCoworkers} room={room}/>


        return (
            <Tabs
                active={this.state.selectedIndex}
                header={[tab0H, tab1H, tab2H, tab3H]}
                body={[tab0, tab1, tab2, tab3]}
            />
        );
    }
}

function mapStateToProps(state, ownProps) {
    const room = ownProps.room;
    const conversation = ConversationSelector.getByRoom(state, room);
    const customerId = ConversationSelector.getCustomerId(conversation);
    const customer = CustomerSelector.getById(state, customerId)
    const onlineCoworkers = EmployeesSelector.getOnlineCoworkers(state);
    return { conversation, customer, onlineCoworkers, room };
}

export default connect(mapStateToProps, null)(AssignedOptions);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/Conversation/Archived/index.js